import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import {
  Dropdown,
  DropdownItem,
} from 'components/shared/DesignSystem/Dropdown';

import { Modal } from 'components/core/modal/constants';
import useDeleteSubtask from './hooks/useSubtaskDelete';
import { useModal } from 'components/shared/hooks';
import { translate } from 'javascripts/translations/i18n';

const MenuIcon = styled.i`
  cursor: pointer;
  font-size: 24px;
  color: var(--cc_color_link_subtle);
  top: 16px;
`;

const SubtaskOptionsDropdown = ({
  subtaskId,
  task,
  isTemplate,
  deleteSubtaskTemplate,
}) => {
  const { showModal, hideModal } = useModal();
  const { deleteSubtask } = useDeleteSubtask({
    taskId: task.id,
    close: hideModal,
  });

  const onConfirmDelete = async () => {
    if (isTemplate) {
      await deleteSubtaskTemplate({
        variables: { input: { id: subtaskId } },
      });
    } else {
      await deleteSubtask({
        variables: { input: { id: subtaskId } },
      });
    }
    hideModal(Modal.confirmAction);
  };

  const handleSubtaskDelete = (closeMenu) => {
    showModal(Modal.CONFIRMATION, {
      title: translate('project.taskList.subTasks.deleteTitle'),
      message: translate('project.taskList.subTasks.deleteMessage'),
      cancelLabel: translate('common.cancelDelete'),
      confirmLabel: translate('common.confirmDelete'),
      onRequestClose: closeMenu,
      confirmAction: onConfirmDelete,
    });
  };

  return (
    <Dropdown
      style={{ width: 180, right: 0 }}
      triggerContent={<MenuIcon className="mdi mdi-dots-horizontal" />}
    >
      {({ closeMenu }) => (
        <DropdownItem
          type="button"
          onClick={() => handleSubtaskDelete(closeMenu)}
        >
          <i className="mdi mdi-delete-outline" />
          {translate('project.taskList.subTasks.deleteTitle')}
        </DropdownItem>
      )}
    </Dropdown>
  );
};

SubtaskOptionsDropdown.propTypes = {
  isTemplate: PropTypes.bool,
  subtaskId: PropTypes.string.isRequired,
  task: PropTypes.shape({
    id: PropTypes.string,
  }),
  deleteSubtaskTemplate: PropTypes.func.isRequired,
};

export default SubtaskOptionsDropdown;
